import React from "react";
import {
  Badge,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import "./artist-detail-modal.scss";
import { payoutDetailRows } from "../../../utils/payoutDetails";

const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const DetailItem = ({ label, value }) => (
  <div className="art-detail-item">
    <dt className="art-detail-item__label">{label}</dt>
    <dd className="art-detail-item__value">{value ?? "—"}</dd>
  </div>
);

const ArtistDetailModal = ({ isOpen, toggle, artist }) => {
  if (!artist) return null;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      className="art-detail-modal"
      centered
    >
      <ModalHeader toggle={toggle} className="art-detail-modal__header">
        <div className="art-detail-modal__title-wrap">
          <span className="art-detail-modal__title">
            {artist.artist_name || artist.name || "Artist"}
          </span>
          <div className="art-detail-modal__badges">
            {artist.is_active ? (
              <Badge color="success">Active</Badge>
            ) : (
              <Badge color="secondary">Inactive</Badge>
            )}
            {artist.youtube_connected ? (
              <Badge color="success">YouTube linked</Badge>
            ) : (
              <Badge color="light" className="text-dark">
                YouTube unlinked
              </Badge>
            )}
            {artist.has_deals ? (
              <Badge color="success">
                {artist.deals_count} deal{artist.deals_count === 1 ? "" : "s"}
              </Badge>
            ) : (
              <Badge color="warning">No deals</Badge>
            )}
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="art-detail-modal__body">
        <section className="art-detail-section">
          <h6 className="art-detail-section__title">Profile</h6>
          <dl className="art-detail-grid">
            <DetailItem label="Red Artist ID" value={artist.red_artist_id} />
            <DetailItem label="Full name" value={artist.full_name} />
            <DetailItem label="Email" value={artist.artist_email} />
            <DetailItem label="Phone" value={artist.phone_number} />
            <DetailItem label="Address" value={artist.adress} />
            <DetailItem label="Currency" value={artist.currency} />
            <DetailItem label="CAR IPI" value={artist.car_ipi} />
            <DetailItem label="Channel ID" value={artist.chanelId} />
            <DetailItem
              label="Deals"
              value={
                artist.has_deals
                  ? `${artist.deals_count} label deal(s) synced`
                  : "No deals synced from CMS"
              }
            />
          </dl>
        </section>

        <section className="art-detail-section">
          <h6 className="art-detail-section__title">Label</h6>
          <dl className="art-detail-grid">
            <DetailItem label="Label" value={artist.label_name} />
            <DetailItem label="Label Red ID" value={artist.label_red_id} />
          </dl>
        </section>

        <section className="art-detail-section">
          <h6 className="art-detail-section__title">YouTube</h6>
          <dl className="art-detail-grid">
            <DetailItem
              label="Invite sent"
              value={formatDate(artist.youtube_invitation_sent_at)}
            />
            <DetailItem
              label="Connected at"
              value={formatDate(artist.youtube_oauth_connected_at)}
            />
          </dl>
        </section>

        <section className="art-detail-section">
          <h6 className="art-detail-section__title">Withdrawal</h6>
          <dl className="art-detail-grid">
            {payoutDetailRows(artist).map((row) => (
              <DetailItem key={row.label} label={row.label} value={row.value} />
            ))}
          </dl>
        </section>

        <section className="art-detail-section">
          <h6 className="art-detail-section__title">Timestamps</h6>
          <dl className="art-detail-grid">
            <DetailItem label="Created" value={formatDate(artist.created_at)} />
            <DetailItem label="Updated" value={formatDate(artist.updated_at)} />
            {artist.deleted_at_from_cms ? (
              <DetailItem
                label="Removed from CMS"
                value={formatDate(artist.deleted_at_from_cms)}
              />
            ) : null}
          </dl>
        </section>
      </ModalBody>
    </Modal>
  );
};

export default ArtistDetailModal;
